// extracted by css-extract-rspack-plugin
export default {"checkboxChecked":"_checkboxChecked_oa4N0"};